import { useQuery } from "@/api/swr/useQuery";
import { appAssessmentProgressSchema } from "@/schema/AssessmentProgress";
import { z } from "zod";

export const useGetAssessmentHistory = () => {
  return useQuery(
    z.array(appAssessmentProgressSchema),
    "/app/assessment_history",
  );
};
